module.exports = __webpack_public_path__ + "static/media/comment.df5ecd22.svg";